(() => {
  const desktopHover = window.matchMedia(
    '(min-width: 990px) and (hover: hover) and (pointer: fine)'
  );

  const initializeLanguageHover = (root = document) => {
    if (!desktopHover.matches) return;
    root
      .querySelectorAll(
        '.localization-form .disclosure'
      )
      .forEach((disclosure) => {
        if (
          disclosure.dataset.senyokoHoverInitialized ===
          'true'
        ) {
          return;
        }

        disclosure.dataset.senyokoHoverInitialized =
          'true';

        const button = disclosure.querySelector(
          ':scope > .disclosure__button'
        );

        if (!button) return;

        let closeTimer;

        const isOpen = () =>
          button.getAttribute('aria-expanded') ===
          'true';

        const openSelector = () => {
          if (!desktopHover.matches || isOpen()) return;

          window.clearTimeout(closeTimer);
          button.click();
        };

        const scheduleClose = () => {
          if (!desktopHover.matches || !isOpen()) {
            return;
          }

          window.clearTimeout(closeTimer);

          closeTimer = window.setTimeout(() => {
            if (isOpen()) {
              button.click();
            }
          }, 220);
        };

        disclosure.addEventListener(
          'mouseenter',
          openSelector
        );

        disclosure.addEventListener(
          'mouseleave',
          scheduleClose
        );

        disclosure.addEventListener(
          'focusin',
          openSelector
        );
      });
  };

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      () => initializeLanguageHover(),
      { once: true }
    );
  } else {
    initializeLanguageHover();
  }

  document.addEventListener(
    'shopify:section:load',
    (event) => {
      initializeLanguageHover(event.target);
    }
  );
})();